module.exports = __webpack_public_path__ + "img/pop_web_sharf.bcec17d3.png";